import React from 'react';
import './ToggleSwitch.css';

interface Props {
  labelText: string;
  checked: boolean;
  onChange: (event : React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const ToggleSwitch: React.FC<Props> = ({ labelText, checked, onChange, disabled = false}) => {

  return (
    <div className="toggle-switch">
      <span className='toggle-switch-text'>{labelText}</span>
      <label className="switch">
        <input type="checkbox" disabled={disabled} checked={checked} onChange={onChange} />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
